import { fromJS } from 'immutable';

import { startAuthCheck, finishAuthCheck, setUserLogin, startLogin } from './actions';

export const defaultState = fromJS({
  hasAuthCheckFinished: false,
  hasAuthCheckStarted: false,
  hasLoginStarted: false,
  userToken: null
});

export default function auth(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration
  switch (action.type) {
    case startAuthCheck.type:
      return newState.set('hasAuthCheckStarted', true).set('hasAuthCheckFinished', false);
    case finishAuthCheck.type:
      return newState.set('hasAuthCheckFinished', true);
    case setUserLogin.type:
      return newState.set('userToken', action.payload);
    case startLogin.type:
      return newState.set('hasLoginStarted', true);
    default:
      return newState;
  }
}

export const isLoggedIn = state => state.auth.get('userToken') !== null;
export const hasLoginStarted = state => state.auth.get('hasLoginStarted');
export const hasAuthCheckStarted = state => state.auth.get('hasAuthCheckStarted');
export const hasAuthCheckFinished = state => state.auth.get('hasAuthCheckFinished');
